// ABOUTME: Utility functions for safe localStorage operations
// ABOUTME: Provides error handling for localStorage access to prevent test crashes

export const safeLocalStorageGet = (key: string, defaultValue: string = ''): string => {
  try {
    return window.localStorage.getItem(key) ?? defaultValue;
  } catch (error) {
    console.warn(`Failed to get localStorage item "${key}":`, error);
    return defaultValue;
  }
};

export const safeLocalStorageSet = (key: string, value: string): boolean => {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.warn(`Failed to set localStorage item "${key}":`, error);
    return false;
  }
};

export const safeLocalStorageRemove = (key: string): boolean => {
  try {
    window.localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.warn(`Failed to remove localStorage item "${key}":`, error);
    return false;
  }
};

export const safeLocalStorageClear = (): boolean => {
  try {
    window.localStorage.clear();
    return true;
  } catch (error) {
    console.warn('Failed to clear localStorage:', error);
    return false;
  }
};
